import { useTranslation } from "react-i18next";

export const UnsupportedDevicePage = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen gradient-warm flex flex-col items-center justify-center px-6 text-center pb-safe">
      <div className="text-6xl mb-6" aria-hidden="true">
        📱
      </div>
      <h1 className="display-font text-2xl sm:text-3xl font-semibold text-ink leading-tight max-w-sm">
        {t("unsupportedDevice.title", "Page accessible uniquement depuis un téléphone")}
      </h1>
      <p className="text-ink-soft max-w-sm mt-4 leading-relaxed">
        {t(
          "unsupportedDevice.description",
          "Pour passer commande, scannez le QR code de votre table avec l'appareil photo de votre smartphone. La page se chargera automatiquement."
        )}
      </p>
    </div>
  );
};
